/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/




/*-----------------------------------------------------------------------------/
/ open nav dropdown on click
/-----------------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function() {
  // Target header details disclosures
  const headerDetailsDisclosures = document.querySelectorAll('header-details-disclosure');
  
  headerDetailsDisclosures.forEach(disclosure => {
    // Get the details element
    const details = disclosure.querySelector('details');
    
    if (details) {
      // Clone summary to replace it (to remove existing event listeners)
      const summary = details.querySelector('summary');
      const newSummary = summary.cloneNode(true);
      summary.parentNode.replaceChild(newSummary, summary);
      
      // Stop mouseenter/mouseover and mouseleave events completely
      disclosure.addEventListener('mouseenter', function(e) {
        e.stopPropagation();
        e.preventDefault();
      }, true);
      
      disclosure.addEventListener('mouseleave', function(e) {
        e.stopPropagation();
        e.preventDefault();
      }, true);
      
      details.addEventListener('mouseenter', function(e) {
        e.stopPropagation();
        e.preventDefault();
      }, true);
      
      details.addEventListener('mouseleave', function(e) {
        e.stopPropagation();
        e.preventDefault();
      }, true);
      
      // Add click behavior
      newSummary.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Close all other dropdowns
        headerDetailsDisclosures.forEach(otherDisc => {
          const otherDetails = otherDisc.querySelector('details');
          if (otherDetails && otherDetails !== details && otherDetails.hasAttribute('open')) {
            otherDetails.removeAttribute('open');
          }
        });
        
        // Toggle current dropdown
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
        }
      });
    }
  });
  
  // Close dropdowns only when clicking outside the navigation completely
  document.addEventListener('click', function(e) {
    if (!e.target.closest('header-details-disclosure') && !e.target.closest('.nav__sub')) {
      headerDetailsDisclosures.forEach(disc => {
        const details = disc.querySelector('details');
        if (details && details.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      });
    }
  });
});
/*-----------------------------------------------------------------------------/
/ Smooth Scroll
/-----------------------------------------------------------------------------*/

$(document).ready(function() {
$('a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500, function() {
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr('tabindex','-1');
            $target.focus();
          };
        });
      }
    }
  });
});
